// utils/addressHelpers.js
import { getCountryConfig } from '../components/services/address/countryConfig';

/*
 * Normalizza un campo in base al paese
 */
export const normalizeField = (countryCode, fieldName, value) => {
    if (!value) return value;
    
    switch (countryCode) {
        case 'IT':
            if (fieldName === 'codFiscale') return value.toUpperCase();
            if (fieldName === 'cap') return value.replace(/\D/g, '');
            break;
        case 'FR':
            if (fieldName === 'codePostal') return value.replace(/\D/g, '');
            break;
        case 'ES':
            if (fieldName === 'codigoPostal') return value.replace(/\D/g, '');
            if (fieldName === 'nif') return value.toUpperCase();
            break;
        case 'PT':
            if (fieldName === 'codigoPostal') return value.replace(/\s/g, '');
            if (fieldName === 'nif') return value.replace(/\D/g, '');
            break;
        default:  // ✅ Aggiunto default case
            // Per altri paesi, nessuna normalizzazione speciale
            break;
    }
    
    return value;
};

/*
 * Valida un campo in base alla configurazione del paese
 */
export const validateField = (countryConfig, fieldName, value) => {
    const field = countryConfig.fields.find(f => f.name === fieldName);
    if (!field) return { valid: true };
    
    // Campo required
    if (field.required && (!value || value.trim() === '')) {
        return { valid: false, message: `${field.label} è obbligatorio` };
    }
    
    // Pattern regex
    if (field.pattern && value && !new RegExp(field.pattern).test(value)) {
        return { valid: false, message: `${field.label} non valido` };
    }
    
    // Validatore custom
    if (countryConfig.validators?.[fieldName]) {
        if (!countryConfig.validators[fieldName](value)) {
            return { valid: false, message: `${field.label} non valido` };
        }
    }
    
    return { valid: true };
};

/*
 * Formatta i dati per l'invio al backend
 */
export const formatForBackend = (countryCode, formData) => {
    const backendData = {
        nazione: countryCode,
        nome: formData.nome || formData.nom || formData.nombre || formData.nome || '',
        cognome: formData.cognome || formData.prenom || formData.apellido || formData.apelido || '',
        azienda: formData.azienda || formData.entreprise || formData.empresa || null,
        indirizzo: formData.indirizzo || formData.adresse || formData.direccion || formData.morada || '',
        indirizzo2: formData.indirizzo2 || formData.adresse2 || formData.direccion2 || formData.morada2 || null,
        citta: formData.citta || formData.ville || formData.ciudad || formData.cidade || '',
        provincia: formData.provincia || formData.distrito || '',
        cap: formData.cap || formData.codePostal || formData.codigoPostal || '',
        telefono: formData.telefono || formData.telephone || formData.telefone || '',
        email: formData.email || '',
        codfiscale: formData.codFiscale || formData.nif || null,
        partita_iva: formData.partitaIva || null
    };
    
    // Rimuovi campi vuoti
    Object.keys(backendData).forEach(key => {
        if (backendData[key] === '' || backendData[key] === null) {
            delete backendData[key];
        }
    });
    
    return backendData;
};

/*
 * Formatta i dati per la visualizzazione
 */
export const formatAddressForDisplay = (countryCode, data) => {
    const config = getCountryConfig(countryCode);
    let formatted = config.addressFormat;
    
    Object.keys(data).forEach(key => {
        const placeholder = `{${key}}`;
        if (formatted.includes(placeholder)) {
            formatted = formatted.replace(placeholder, data[key] || '');
        }
    });
    
    // Rimuovi righe vuote
    return formatted.split('\n').filter(line => line.trim()).join('\n');
};
